export const firebaseConfig = {
  apiKey: "AIzaSyAVYT8JSOHtWj-Rsw3kFZXmDRtx89i1Pi8",
  authDomain: "travel-guru-5b409.firebaseapp.com",
  databaseURL: "https://travel-guru-5b409.firebaseio.com",
  projectId: "travel-guru-5b409",
  storageBucket: "travel-guru-5b409.appspot.com",
  messagingSenderId: "382380894715",
  appId: "1:382380894715:web:c1cc3b397e5b77b2c4435e"
};